function Logo({ isLight = false }) {
  const logoColor = isLight
    ? "var(--color-grey-100)"
    : "var(--color-primary-dark)";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        width="26"
        height="29"
        viewBox="0 0 26 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_359_365"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="7"
          width="13"
          height="22"
        >
          <path
            d="M0.5625 21.7313L12.8079 28.8017L12.8481 14.6641L0.602641 7.59375L0.5625 21.7313Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_359_365)">
          <path
            d="M7.22437 11.4149C7.01737 11.2953 6.82689 11.189 6.66003 11.0961C6.49317 11.0033 6.34913 10.9238 6.23422 10.8569C6.15709 10.812 6.09333 10.7742 6.04453 10.7412C5.97291 10.6947 5.75804 10.5688 5.4495 10.3909C4.95049 10.1028 4.20827 9.6794 3.44323 9.24257C2.67976 8.80653 1.89268 8.3571 1.30001 8.01551C1.0143 7.85101 0.774237 7.71091 0.60344 7.60938L0.592421 11.4078C0.592421 11.4078 2.66481 12.6278 4.18387 13.5046L4.18309 12.4775C4.30351 12.5499 4.43416 12.627 4.57426 12.7073C4.80724 12.8419 5.06383 12.9867 5.33301 13.1394C5.60298 13.2921 5.88633 13.4527 6.17125 13.6172C6.95755 14.0713 7.76273 14.5601 8.36564 15.0237C8.46402 15.1016 8.68755 15.2834 8.90557 15.5975C9.25031 16.0729 9.37152 16.6167 9.29675 16.9764C9.28416 17.0504 9.26055 17.1976 9.17161 17.3039C9.12596 17.3582 8.85363 17.6588 8.15706 17.4691C7.90283 17.3999 7.66592 17.285 7.43924 17.1756C6.55456 16.6647 5.32435 15.9548 4.46486 15.4589C4.35939 15.3975 4.25865 15.3401 4.16577 15.2858L4.1579 18.1846C4.61913 18.4514 5.47626 18.9449 6.28381 19.4109C6.96857 19.806 7.61791 20.1822 7.96029 20.3829C8.11534 20.4734 8.23262 20.5482 8.34753 20.634C8.38767 20.6639 8.44592 20.7096 8.51361 20.7678C9.2393 21.362 10.0012 22.8032 9.23615 23.2282C8.65056 23.484 7.90992 23.1841 6.86861 22.5867C6.56873 22.4167 5.85012 22.0027 5.22125 21.6399C4.61834 21.292 4.09729 20.9898 4.10202 20.9929L4.10753 19.1653L0.575892 17.126L0.562512 21.7249C0.56015 21.7233 0.918272 21.9303 1.36533 22.1885C1.79666 22.438 2.31219 22.7347 2.66874 22.9394C2.95445 23.1031 3.20868 23.2495 3.43536 23.3801C3.9934 23.702 4.38615 23.9311 4.68052 24.1035C4.9741 24.275 5.17009 24.3907 5.33459 24.486C5.42667 24.5395 5.50932 24.5859 5.59432 24.6332C6.2232 24.9622 6.86467 25.3282 7.46049 25.6721C7.56911 25.7351 7.67694 25.7973 7.78241 25.8579C7.88866 25.9192 7.99335 25.9799 8.09567 26.0389C8.79381 26.4419 9.38412 26.7756 9.74932 26.922C11.4722 27.6626 12.8638 26.652 12.8205 24.6371C12.8418 23.2534 12.715 22.1192 11.4699 20.6309C11.939 20.4223 12.4482 20.5096 12.778 19.2857C13.0204 18.2279 12.3546 16.2137 11.3164 14.7939C10.1783 13.2362 8.41994 12.1052 7.22437 11.4149Z"
            fill={logoColor}
          />
        </g>
        <mask
          id="mask1_359_365"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="26"
          height="15"
        >
          <path
            d="M0.867188 7.02942L13.0418 14.0588L25.1376 7.02942L12.9631 0L0.867188 7.02942Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_359_365)">
          <path
            d="M25.1376 7.02942L12.9631 0L9.99497 1.72528L13.9414 7.56621L3.85495 5.29312L0.867188 7.02942L13.0418 14.0588L15.9422 12.3737L10.6254 9.30409L16.401 10.5981L19.1841 8.9806L16.9449 5.65833L22.238 8.71456L25.1376 7.02942Z"
            fill={logoColor}
          />
        </g>
        <mask
          id="mask2_359_365"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="13"
          y="7"
          width="13"
          height="21"
        >
          <path
            d="M13.4141 14.5752L13.4518 27.9359L25.369 21.0552L25.3313 7.69531L13.4141 14.5752Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_359_365)">
          <path
            d="M21.7807 9.74204L16.9897 12.5078C14.6065 13.8837 13.4156 14.9871 13.418 15.8159L13.4298 19.9993C13.4321 20.8344 14.6285 21.8804 17.0126 20.5046L21.7799 17.7522L21.7878 20.4582L17.0204 23.2106L17.0173 22.1102L13.4416 24.1748L13.4487 26.68C13.451 27.5151 14.6442 27.2444 17.0275 25.8686L21.7949 23.1161C24.1144 21.7765 25.3053 20.6715 25.3667 19.7994L25.3509 14.3717C25.3328 13.546 24.1475 13.812 21.7957 15.1698L17.0047 17.9356L16.9968 15.165L21.7642 12.4276L21.7673 13.5129L25.3423 11.4484L25.3352 8.94315C25.3336 8.10885 24.1483 8.37488 21.7807 9.74204Z"
            fill={logoColor}
          />
        </g>
      </svg>
    </div>
  );
}

export default Logo;
